export default __webpack_public_path__ + "static/media/NE.e00e90dd.jpg";